import React, { useEffect, useState, createContext, useContext } from "react";
import { supabase } from "./supabaseClient";
import { User } from "@supabase/supabase-js";

const AuthContext = createContext<{
  user: User | null;
  signIn: () => void;
  signOutUser: () => void;
}>({
  user: null,
  signIn: () => {},
  signOutUser: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    // Get current user on mount
    supabase.auth.getSession().then(({ data }) => {
      setUser(data.session?.user ?? null);
    });

    // Listen for auth changes
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      listener?.subscription.unsubscribe();
    };
  }, []);

  const signIn = () => {
    supabase.auth.signInWithOAuth({ provider: "google" });
  };

  const signOutUser = () => {
    supabase.auth.signOut();
  };

  return (
    <AuthContext.Provider value={{ user, signIn, signOutUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);